import { Component, EventEmitter, inject, input, Input, OnInit, Output } from '@angular/core';
import { InputBase } from '../input-base';
import { IFileUploadResult } from '../../../models/i-file-upload-result';
import { FileUploadDialogComponent } from '../../file-upload-dialog/file-upload-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ControlValueAccessor } from '@angular/forms';
import { DecisionDetails } from '../../../data/decision-details';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss'
})
export class FileUploadComponent {
 
  @Input() uploadType: string | null = null;
  @Input() matterId: string | null = null;
  @Input() clientId: number | null = null;
  @Input() label: string = 'Upload File';
  @Input() disabled: boolean = false;
  @Input() placeholder: string = 'Upload File';
  @Input() displayValue: string = '';

  
  @Output() change = new EventEmitter<IFileUploadResult | null>();
  
  private dialog = inject(MatDialog);
  
  value: IFileUploadResult | null = null;
  fileUploadErrorMessage = '';

  get hasFile(): boolean {
    return this.value?.fileId ? true : false;
  }

  openUploadDialog(): void {
     
    if(!this.hasFile){
      const dialogRef = this.dialog.open(FileUploadDialogComponent, {
        width: '600px',
        data: {
          uploadType: this.uploadType
        , matterId: this.matterId
        , clientId: this.clientId
        }
      });

      dialogRef.afterClosed().subscribe((result: IFileUploadResult | string | undefined) => {
        if (result && this.isFileUploadResult(result)) {
          this.value = result;
          this.updateDisplayValue();
          this.updateErrorMessage();
          this.change.emit(this.value);
        } else if (typeof result === 'string') {
          this.fileUploadErrorMessage = result;
        }

      });
  }
  }

private isFileUploadResult(obj: any): obj is IFileUploadResult {
  return obj.fileId !== undefined && obj.file?.name !== undefined && obj.key !== undefined;
}

  removeFile(): void {
    this.value = null;
    this.updateDisplayValue();
    this.fileUploadErrorMessage = '';
    this.change.emit(this.value);
  }

  private updateDisplayValue(): void {
    this.displayValue = this.value?.file?.name || '';
  }

  private updateErrorMessage(): void {
    if (this.value?.fileValidationResult && !this.value.fileValidationResult.isValid) {
      this.fileUploadErrorMessage = this.value.fileValidationResult.error;
    } else {
      this.fileUploadErrorMessage = '';
    }
  }
}
